import { render, staticRenderFns } from "./industryComparison.vue?vue&type=template&id=35c85980&scoped=true&"
import script from "./industryComparison.vue?vue&type=script&lang=js&"
export * from "./industryComparison.vue?vue&type=script&lang=js&"
import style0 from "./industryComparison.vue?vue&type=style&index=0&id=35c85980&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c85980",
  null
  
)

export default component.exports